<template>
  <div class="finalSummary" :key="`tab_content_8` + $store.state.calculatorData.calculatorPages[8].disabled">
    <h2>{{ $t(`finalSummary.title`)}}</h2>
    <div class="summaryContent intro">
      <!-- <p v-html="$t(`finalSummary.infoText`)"></p> -->
    </div>
    <div class="highlight-box">
      <table>
        <tr>
          <td v-html="$t(`insulationMaterial.title`)"></td>
          <td v-html="$t(`insulationMaterial.${insulationMaterial}.title`)"></td>
        </tr>
        <tr>
          <td v-html="$t(`elementForm.title`)"></td>
          <td v-html="$t(`elementForm.${elementForm}.title`)"></td>
        </tr>
        <tr>
          <td v-html="$t(`variablesNice.a`)"></td>
          <td>{{ a }} mm</td>
        </tr>
        <tr>
          <td v-html="$t(`variablesNice.a1`)"></td>
          <td>{{ a1 }} mm</td>
        </tr>
        <tr>
          <td v-html="$t(`variablesNice.a2`)"></td>
          <td>{{ a2 }} mm</td>
        </tr>
        <tr>
          <td v-html="$t(`variablesNice.c`)"></td>
          <td>{{ c }} mm</td>
        </tr>
        <tr>
          <td v-html="$t(`variablesNice.d1`)"></td>
          <td>{{ d1 }} mm</td>
        </tr>
        <tr>
          <td v-html="$t(`variablesNice.e`)"></td>
          <td>{{ e }} mm</td>
        </tr>
        <tr>
          <td v-html="$t(`variablesNice.b`)"></td>
          <td>{{ b }} mm</td>
        </tr>
        <tr>
          <td v-html="$t(`vacuumPanels.title`)"></td>
          <td v-html="$t(`vacuumPanels.${vacuumPanels}.title`)"></td>
        </tr>
        <tr>
          <td v-html="$t(`notches.title`)"></td>
          <td v-html="$t(`notches.${notches}.title`)"></td>
        </tr>
        <tr v-if="notches !== 'noNotch'">
          <td v-html="$t(`variablesNice.g`)"></td>
          <td>{{ g }} mm</td>
        </tr>
        <tr v-if="notches !== 'noNotch'">
          <td v-html="$t(`variablesNice.f`)"></td>
          <td>{{ f }} mm</td>
        </tr>
        <tr v-if="isBox === true">
          <td v-html="$t(`wallProfiles.title`)"></td>
          <td v-html="$t(`wallProfiles.${wallProfiles}.title`)"></td>
        </tr>
        <tr v-if="(elementForm !== 'jasp') && (elementForm !== 'jasa')">
          <td v-html="$t(`endProfiles.stripColor.title`)"></td>
          <td>{{ getNiceProfilColor() }}</td>
        </tr>
        <tr v-if="dripEdgeProfile">
          <td v-html="$t(`dripEdgeProfile.title`)"></td>
          <td>{{ dripEdgeProfile }} mm</td>
        </tr>
      </table>
    </div>
    <div class="summaryContent outro">
      <p v-html="$t(`finalSummary.outro`)"></p>
    </div>
    <div>
      <button @click="downloadPDF()"> {{ $t(`finalSummary.downloadButton`)}}</button>
      <p v-if="pdfStatus === 'serverRequestStart'">
        {{ $t(`pdf.pdfStatus.serverRequestStart`)}}
      </p>
      <p v-else-if="pdfStatus === 'serverError'">
        {{ $t(`pdf.pdfStatus.serverError`)}}
      </p>
      <p v-else-if="pdfStatus === 'serverPDFCreatingError'">
        {{ $t(`pdf.pdfStatus.serverPDFCreatingError`)}}
      </p>
      <p v-else-if="pdfStatus === 'serverAutoDownload'">
        {{ $t(`pdf.pdfStatus.serverAutoDownload`)}}
      </p>
    </div>

    <StepNavi thisPage="8" :key="`navi_tab8_`+ $store.state.calculatorData.calculatorPages[8].disabled"/>
  </div>
</template>

<script>
import StepNavi from './StepNavi.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'FinalSummary',
  components: {
    StepNavi
  },
  data () {
    return {
      pdfStatus: ''
    }
  },
  computed: {
    ...mapGetters([
      'insulationMaterial',
      'elementForm',
      'a',
      'a1',
      'a2',
      'c',
      'd1',
      'e',
      'b',
      'vacuumPanels',
      'g',
      'f',
      'wallProfiles',
      'profilColor',
      'dripEdgeProfile',
      'notches',
      'isBox'
    ])
  },
  methods: {
    downloadPDF: function (event) {
      // this line needs to track only User Input
      this.$root.$children['0'].userDidAction = true

      const fileName = this.$t(`pdf.pdfFileNamePrefix`) + this.$store.state.calculatorData.currentOrder.elementForm + '.pdf'
      // var myOrder = {}
      let myOrder = Object.assign({}, this.$store.state.calculatorData.currentOrder)
      myOrder.elementForm = this.$t(`elementForm.${myOrder.elementForm}.pdfTitle`)
      myOrder.wallProfiles = this.$t(`wallProfiles.${myOrder.wallProfiles}.niceShort`)
      myOrder.vacuumPanels = (myOrder.vacuumPanels === 'vip')
      myOrder.dripEdgeProfile = parseInt(myOrder.dripEdgeProfile)
      myOrder.imgPathforPDF = '/img/pdfimages/' + this.$store.state.calculatorData.currentOrder.elementForm + '.jpg'
      this.pdfStatus = 'serverAutoDownload'
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_LOCAL_API_URL + '/pdf',
        data: {
          pdf_info: myOrder
        },
        responseType: 'blob'
      }).then(r => {
        if (r.status === 200) {
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.tracking('Bestellformular (PDF) runterladen')
        } else if (r.status === 400) {
          this.store = 'serverPDFCreatingError'
          this.tracking('Error Creating PDF')
        }
      }).catch(error => {
        this.pdfStatus = 'serverError'
        console.log(error.response)
        this.tracking(this.pdfStatus)
      })
    },
    tracking: function (status) {
      let gtmEvent = 'JKK-Events'
      let gtmEventCategory = 'Zusammenfassung'
      let gtmEventAction = 'Button'
      let gtmEventLabel = status
      let virtualPageURL = '/zusammenfassung'
      let virtualPageTitle = 'Zusammenfassung'
      this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, '', virtualPageURL, virtualPageTitle)
    },
    getNiceProfilColor: function () {
      let color = this.profilColor
      switch (color) {
        case 'alu':
          color = 'Alu Natur'
          break
        case 'white':
          color = 'Weiß'
          break
        case 'on':
          color = 'bitte wählen'
          break
        default:
          color = this.profilColor
      }
      return color
    }
  },
  mounted: function () {
    // console.log('--- FinalSummary rendert ---')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.summaryContent{
  padding: 2rem 0 1rem 0;
}
</style>
